import { Modal, Button, message, Input } from 'antd';
import React, { useState } from 'react';
import { updateDB } from './indexedDB.js'

const AddAddressModal = (props) => {
	const { db, showing, setShowing, lat, lon } = props;
	const [loc, setLoc] = useState('');

	const handleToBase = () => {
		if (loc !== '') {
			updateDB(db, "Cords", { loc: loc, lat: lat, lon: lon });
			message.success(`“${loc}”加入地名库成功`);
			setShowing(false);
			setLoc('');
		} else {
			message.error(`请输入地名`);
		}
	};

	const handleCancel = () => {
		setShowing(false);
		setLoc('');
	}

	const handleKeyUp = (e) => {
		e.preventDefault()
		if (e.keyCode !== 13) {
			return
		} else {
			handleToBase();
		}
	}

	return (
		<Modal open={showing} onCancel={handleCancel} width={'40dvw'}
			title="加入地名库" maskClosable={true} footer={[
				<Button size='small' key="tomap" type="primary" onClick={handleToBase}>入库</Button>,
				<Button size='small' key="cancel" type="default" onClick={handleCancel}>取消</Button>
			]}>
			<Input type='text' placeholder='请输入地名……' value={loc} onChange={(e) => { setLoc(e.target.value) }}
				onKeyUp={handleKeyUp} />
			<span >经度：{lon}</span><br />
			<span >纬度：{lat}</span>
		</Modal>
	)
};

export default AddAddressModal;